import type { NavigateFunction } from 'react-router-dom';

export function updateUrlParams(
  navigate: NavigateFunction,
  params: {
    siteId?: string;
    buildingId?: string;
    floorId?: string;
    roomId?: string;
    zoneId?: string;
    selected?: string;
  },
) {
  const currentUrl = new URL(location.href);
  const searchParams = new URLSearchParams(currentUrl.search);

  // Handle siteId — used by Devices to scope the device list to a Site.
  if (params.siteId) {
    searchParams.set('siteId', params.siteId);
  } else {
    searchParams.delete('siteId');
  }
  // Handle floorId (spaceId)
  if (params.floorId) {
    searchParams.set('spaceId', params.floorId);
  } else {
    searchParams.delete('spaceId');
  }
  // Handle buildingId
  if (params.buildingId) {
    searchParams.set('buildingId', params.buildingId);
  } else {
    searchParams.delete('buildingId');
  }
  // Handle roomId
  if (params.roomId) {
    searchParams.set('roomId', params.roomId);
  } else {
    searchParams.delete('roomId');
  }

  // Handle zoneId
  if (params.zoneId) {
    searchParams.set('zoneId', params.zoneId);
  } else {
    searchParams.delete('zoneId');
  }

  // Handle selected (auto-select items after navigation)
  if (params.selected) {
    searchParams.set('selected', params.selected);
  } else {
    searchParams.delete('selected');
  }

  navigate({ search: searchParams.toString() });
}
